import { render } from "./ShowTransfer.vue?vue&type=template&id=7d118f26"
import script from "./ShowTransfer.vue?vue&type=script&lang=js"
export * from "./ShowTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__